// extracted by mini-css-extract-plugin
module.exports = {"p3":"P3_p3__1_bI8"};